import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '917760180840';
  const message = encodeURIComponent('Hello! I would like to inquire about your diesel generator services.');

  const handleClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <div
      className="whatsapp-float"
      onClick={handleClick}
      data-testid="whatsapp-button"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <MessageCircle size={32} />
    </div>
  );
};
